// Header
import './js/header/header-height-adjust.js';
import './js/header/color-scheme-switcher.js';
import './js/header/burger-mobile.js';

// Fetch
// import './js/fetchSelectedBooks';
import './js/components/spinner.js';

// Sidebar
// Category selection menu
import './js/categories-menu/renderCategoriesList.js';
import './js/categories-menu/activeCatBtnSwitcher.js';
import './js/categories-menu/handleCategoryClick.js';

// Support Ukraine block
import './js/support-ukraine/support.js';

// Content part
import './js/bestsellers/bestsellers';
import './js/bestsellers/seeMore.js';

// Modal - popup
import './js/modal-popup/modal.js';

// Authorization
import './js/firebase/firebase';
import './js/firebase/authservice';
import './js/firebase/firebaseservise';

import './js/modal-login/authorization-form.js';
import './js/modal-login/form-validator.js';

// Scroll-to-top button
import './js/components/back-to-top';
